import type { SVGProps } from 'react';
const SvgSubscriptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#subscriptions_svg__a)">
      <path
        fill="currentColor"
        d="M20 8H4V6h16v2Zm-2-6H6v2h12V2Zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2Zm-6 4-6-3.27v6.53L16 16Z"
      />
    </g>
    <defs>
      <clipPath id="subscriptions_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSubscriptions;
